import { TextField } from '@material-ui/core';
import { changeDefaultGroupLimit, getDefaultGroupLimit } from 'features/settings/settingsSlice';
import { useThunkDispatch } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const DefaultGroupLimitInput = () => {
  const defaultGroupLimit = useSelector(getDefaultGroupLimit);
  const dispatch = useThunkDispatch();
  const { t } = useTranslation();

  return (
    <TextField
      margin="normal"
      label={t('default_group_limit')!}
      defaultValue={defaultGroupLimit}
      onChange={(e) => dispatch(changeDefaultGroupLimit(Number(e.target.value)))}
    />
  );
};

export default DefaultGroupLimitInput;
